import loadable from '@loadable/component';

import { LoadingPageLoadable } from 'modules/main/pages/Loading';

export const ResetPasswordPageContainerLoadable = loadable(
  () =>
    import(
      /* webpackChunkName: "ResetPasswordPageContainer" */
      './ResetPasswordPageContainer.dynamic'
    ),
  { fallback: <LoadingPageLoadable /> },
);
